import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../types';
import { parseLocationParams } from '../utils/utils';
import Page from '../components/page';
import AppBar from '../components/appBar';
import { useLocation } from 'react-router-dom';

export default function ProtocolPage() {
  const location = useLocation();
  const protocol = useSelector((state: AppStore) => state.protocol);
  const [type, setType] = useState('');

  useEffect(() => {
    let { type } = parseLocationParams(location.search);
    setType(type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let p = (protocol?.results ?? []).find((x) => x.type === type);
  return (
    <Page appBar={<AppBar title={p?.title ?? '协议'} />} contentClassName=" vw-100 vh-100 overflow-y pb-60">
      <div className="p-10" dangerouslySetInnerHTML={{ __html: p?.content ?? '' }} />
    </Page>
  );
}
/// 协议类型
export class ProtocolType {
  /// 隐私政策
  static privacy = 'privacy';

  /// 用户协议
  static user = 'user';

  /// 入网协议
  static net_in = 'net_in';
}
